import type { UseFormRegisterReturn } from "react-hook-form";

import { RadioCard } from "@ui/components/RadioCard";
import { useTranslations } from "@ui/providers/useTranslations";

export interface QuantityRadioGroupProps {
  type: "cartons" | "packs";
  groupName: string;
  numberOfElements: number;
  shouldDisplaySubtitle?: boolean;
  registerProps?: Pick<UseFormRegisterReturn<any>, "ref" | "onChange">;
}

export const QuantityRadioGroup = ({
  type,
  groupName,
  numberOfElements,
  shouldDisplaySubtitle = false,
  registerProps,
}: QuantityRadioGroupProps) => {
  const { __ } = useTranslations();
  const quantities = Array.from({ length: numberOfElements }, (_, index) => index + 1);

  return (
    <>
      {quantities.map((quantity) => (
        <RadioCard
          key={quantity}
          value={quantity}
          groupName={groupName}
          title={__(`sticksForm.step.quantity_selection.${type}.title.${quantity}`)}
          subtitle={
            shouldDisplaySubtitle ? __(`sticksForm.step.quantity_selection.${type}.subtitle.${quantity}`) : undefined
          }
          {...registerProps}
        />
      ))}
    </>
  );
};
